import Vue from "vue";
import axios from 'axios';
import { DEFAULT_COLORS } from "../constants/colors";
import { DEFAULT_FONT } from "../constants/fonts";
import { BUILDER_USER_TYPE } from "../constants/custom-define-type";
import { DEFAULT_FAVICON_URL } from "../constants/default-values";


Vue.mixin({
  methods: {
    showErrorDialog(error) {
      if (typeof error === 'string') {
        this.$store.dispatch("setErrorDialog", { key: error });
      } else {
        this.$store.dispatch("setErrorDialog", error);
      }
    },
    hideErrorDialog() {
      this.$store.dispatch("setErrorDialog", null);
    },
    showConfirmDialog(confirm) {
      if (typeof confirm === 'string') {
        this.$store.dispatch("setConfirmDialog", { key: confirm });
      } else {
        this.$store.dispatch("setConfirmDialog", confirm);
      }
    },
    hideConfirmDialog() {
      this.$store.dispatch("setConfirmDialog", null);
    },
    showResultDialog(result) {
      if (typeof result === 'string') {
        this.$store.dispatch("setResultDialog", { key: result });
      } else {
        this.$store.dispatch("setResultDialog", result);
      }
    },
    hideResultDialog() {
      this.$store.dispatch("setResultDialog", null);
    },
    showInfoDialog(infoObject) {
      this.$store.dispatch("setInfoDialog", infoObject);
    },
    hideInfoDialog() {
      this.$store.dispatch("setInfoDialog", null);
    },
    hideToastCountDownConfirm() {
      this.$store.dispatch("setToastCountDownConfirm", null);
    },
    showInputDialog(inputObject) {
      this.$store.dispatch("setInputDialog", inputObject);
    },
    hideInputDialog() {
      this.$store.dispatch("setInputDialog", null);
    },
    showSendEmailDialog(emailObject) {
      this.$store.dispatch("setEmailSending", emailObject);
    },
    hideSendEmailDialog() {
      this.$store.dispatch("setEmailSending", null);
    },
    showFilePreviewDialog(filePreviewObject) {
      this.$store.dispatch("setFilePreview", filePreviewObject);
    },
    hideFilePreviewDialog() {
      this.$store.dispatch("setFilePreview", null);
    },
    showUserProfileDialog(input, isCandidate = false) {
      // Input can be user or user ID
      let isUser = input && typeof input === 'object';
      if (isUser) {
        if (this.$store.getters.isAgent) {
          if (input.is_candidate) {
            this.$store.dispatch("setDisplayingCandidateId", input.id);
          } else {
            this.$store.dispatch("setDisplayingEmployerId", input.id);
          }
          this.$store.dispatch('addRecentAccessLog', {
            type: input.is_candidate ? 'Candidate' : 'Client',
            id: input.id,
            name: `${input.first_name} ${input.last_name}`
          })
        } else {
          this.$store.dispatch("setDisplayingProfileUser", input);
        }
      } else {
        if (this.$store.getters.isAgent) {
          if (isCandidate) {
            this.$store.dispatch("setDisplayingCandidateId", input);
          } else {
            this.$store.dispatch("setDisplayingEmployerId", input);
          }
          this.$store.dispatch('addRecentAccessLog', {
            type: input.is_candidate ? 'Candidate' : 'Client',
            id: input
          })
        } else {
          this.$store.dispatch("setDisplayingProfileUserId", input);
        }
      }
    },
    showLoading() {
      this.$store.dispatch("increaseLoadingReqNumber", 1);
    },
    hideLoading() {
      this.$store.dispatch("increaseLoadingReqNumber", -1);
    },
    setAgency(agency) {
      if (agency == null) {
        agency = {};
      }
      this.$store.dispatch("setAgency", agency);
      try {
        localStorage.setItem("agency", agency);
      } catch (error) {
        console.log(error);
      }
      // Set candidate statuses
      this.$store.dispatch("setCandidateStatuses", agency.candidate_statuses);
      // Set client statuses
      this.$store.dispatch("setEmployerStatuses", agency.employer_statuses);
      // Set candidate checklist
      this.$store.dispatch("setCandidateAdminChecklist", agency.candidate_admin_checklist);
      // Set client checklist
      this.$store.dispatch("setEmployerAdminChecklist", agency.employer_admin_checklist);
      // Set job statuses
      this.$store.dispatch("setPlacementJobStatuses", agency.placement_job_statuses);
      this.$store.dispatch("setShiftJobStatuses", agency.shift_job_statuses);
      this.$store.dispatch(
        "setEmployerLastLoginRetrievalDays",
        agency.client_last_login_retrieval_days
      );
      this.$store.dispatch(
        "setCandidateLastLoginRetrievalDays",
        agency.candidate_last_login_retrieval_days
      );

      //Set badges
      if (agency) {
        this.$store.dispatch("getAllBadges", { agencyId: agency.id });
      }
      this.setPublicAgency(agency);
    },
    setPublicAgency(agency) {
      // Store agency information
      this.$store.dispatch("setAgencyPublic", agency);
      // Load admin emails from agency profile
      const agencyEmails = {
        fromEmail: agency.from_email,
        replyEmail: agency.reply_email,
        adminEmail: agency.admin_email,
      };
      this.$store.dispatch("setAgencyEmails", agencyEmails);

      // Load color variable from agency profile
      const color = {
        primaryColor: DEFAULT_COLORS.PRIMARY,
        secondaryColor: DEFAULT_COLORS.SECONDARY,
        primaryDarkerColor: DEFAULT_COLORS.PRIMARY_DARKER,
        secondaryDarkerColor: DEFAULT_COLORS.SECONDARY_DARKER,
        profileTextColor: DEFAULT_COLORS.PROFILE_TEXT,
        cancelButtonColor: DEFAULT_COLORS.CANCEL_BUTTON,
        cancelButtonHoverColor: DEFAULT_COLORS.CANCEL_BUTTON_HOVER
      };
      if (agency.primary_color !== "") {
        color.primaryColor = agency.primary_color;
      }
      if (agency.primary_darker_color !== "") {
        color.primaryDarkerColor = agency.primary_darker_color;
      }
      if (agency.secondary_color !== "") {
        color.secondaryColor = agency.secondary_color;
      }
      if (agency.secondary_darker_color !== "") {
        color.secondaryDarkerColor = agency.secondary_darker_color;
      }
      if (agency.candidate_profile_text_color !== "") {
        color.profileTextColor = agency.candidate_profile_text_color;
      }
      if (agency.public_advance_setting) {
        if (agency.public_advance_setting.cancel_button_color) {
          color.cancelButtonColor = agency.public_advance_setting.cancel_button_color;
        }
        if (agency.public_advance_setting.cancel_button_hover_color) {
          color.cancelButtonHoverColor = agency.public_advance_setting.cancel_button_hover_color;
        }
        if (agency.public_advance_setting.label_color) {
          color.labelColor = agency.public_advance_setting.label_color;
        }
      }
      this.$store.dispatch("setColor", color);
      // Load root font
      let rootFont = agency.root_font;
      if (!rootFont) {
        rootFont = DEFAULT_FONT.ROOT;
      }
      // Load headings font
      let headingsFont = agency.headings_font;
      if (!headingsFont) {
        headingsFont = DEFAULT_FONT.HEADINGS;
      }

      this.$store.dispatch("setRootFont", rootFont);
      this.$store.dispatch("setHeadingsFont", headingsFont);
      let headingOneCase = true;
      let headingTwoCase = true;
      let headingThreeCase = true;
      let headingOneCapitalize = false;
      let headingTwoCapitalize = false;
      let headingThreeCapitalize = false;

      if (agency.public_advance_setting) {
        //Load h1 heading transformation
        headingOneCase = agency.public_advance_setting.h1_uppercase;

        //Load h2 heading transformation
        headingTwoCase = agency.public_advance_setting.h2_uppercase;

        //Load h2 heading transformation
        headingThreeCase = agency.public_advance_setting.h3_uppercase;

        headingOneCapitalize = agency.public_advance_setting.h1_capitalize;

        headingTwoCapitalize = agency.public_advance_setting.h2_capitalize;

        headingThreeCapitalize = agency.public_advance_setting.h3_capitalize;
      }

      this.$store.dispatch("setRootFont", rootFont);
      this.$store.dispatch("setHeadingsFont", headingsFont);
      this.$store.dispatch("headingOneCase", headingOneCase);
      this.$store.dispatch("headingTwoCase", headingTwoCase);
      this.$store.dispatch("headingThreeCase", headingThreeCase);
      this.$store.dispatch("headingOneCapitalize", headingOneCapitalize);
      this.$store.dispatch("headingTwoCapitalize", headingTwoCapitalize);
      this.$store.dispatch("headingThreeCapitalize", headingThreeCapitalize);

      // Set favicon
      if (agency.favicon) {
        this.setFavicon(this.convertToAbsolutePath(agency.favicon))
      } else {
        this.setFavicon(DEFAULT_FAVICON_URL)
      }

      // Set page title
      if (agency.human_name) {
        document.title = agency.human_name;
      } else {
        document.title = 'Enginehire';
      }

    },
    setFavicon(faviconUrl) {
      const favicon = document.getElementById("favicon");
      favicon.href = faviconUrl;
    },
    // load package list
    loadPackageList() {
      this.$store.dispatch("increaseLoadPackageListReqNumber", 1);
    },
    submitTrackingClick(clickType, selector, objectId = null, additionalInfo = null) {
      if (!selector) {
        selector = window.location.origin + window.location.pathname;
      }
      let userType = '';
      if (this.$store.getters.isCandidate) {
        userType = 'Candidate';
      } else if (this.$store.getters.isEmployer) {
        userType = 'Client';
      } else if (this.$store.getters.isAgent) {
        userType = 'Admin';
      }
      axios.post(this.appendBackgroundParam('/api/click-tracking/'), {
        user: this.$store.getters.userID,
        user_type: userType,
        agency: this.$store.getters.agencyID,
        click_type: clickType,
        selector: selector,
        object_id: objectId,
        additional_info: additionalInfo
      });
    }
  }
});



// WEBPACK FOOTER //
// ./src/mixins/global-actions.js